import { useTranslation } from 'react-i18next';
import React, { useEffect } from 'react';
import { Dropdown } from 'primereact/dropdown';

import classes from './HourlyForm.module.scss';
import { defaultCronObject, Props } from '../CrontabView';

const MINUTES: string[] = Array.from(Array(60).keys()).map(min => min.toString());


export const HourlyForm = ({ onCronChanged, date }: Props) => {
  const { t: translate } = useTranslation();

  useEffect(() => {
    onCronChanged({
      ...defaultCronObject,
      minutes: date.getMinutes().toString()
    });
  }, []);

  const changeHandler = (val: string) => {
    onCronChanged({
      ...defaultCronObject,
      minutes: val,
    });
  };

  return (
    <div className={ classes['form-control'] }>
      <label> { translate('cron-tab.input.at') } </label>
      <Dropdown
      //use method toString to select also the 0 VALUE 
        value={ date.getMinutes().toString() }
        options={ MINUTES }
        onChange={ (e) => changeHandler(e.value) }
      />
      <span className="p-text-secondary">Minutes</span>
    </div>
  );
};